export const INLINE_TOOLBAR_COMMAND = "inline-html-toolbar-command";
export const INLINE_TOOLBAR_STATE = "inline-html-toolbar-state";
export const inlineToolbarCommands = ["Bold", "Italic", "Underline", "Strikethrough", "Superscript", "Subscript", "JustifyLeft", "JustifyCenter", "JustifyRight", "JustifyFull", "InsertUnorderedList", "InsertOrderedList", "Indent", "Outdent", "RemoveFormat", "Undo", "Redo", "FormatBlock", "FontName", "FontSize", "ForeColor", "HiliteColor", "mceLink", "Unlink", "mceImage", "mceMedia", "mceCodeEditor", "mceEmoticons", "mceFullScreen", "Focus"] as const;
export type InlineToolbarCommand = typeof inlineToolbarCommands[number];
export interface InlineToolbarState {
  ready: boolean;
  bold?: boolean;
  italic?: boolean;
  underline?: boolean;
  strikethrough?: boolean;
  unorderedList?: boolean;
  orderedList?: boolean;
  canUndo?: boolean;
  canRedo?: boolean;
  format?: string;
  fontName?: string;
  fontSize?: string;
}
